import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import { IntlProvider } from 'react-intl';
import fa from './i18n/compiled-lang/fa.json';

import storeContainer from 'Config/redux/store';
import PageProvider from 'Components/HOC/PageProvider';
import { isoLangCodes } from 'Constants';

import '@takhfifan/saaghi/lib/theme/theme.scss';
import 'Assets/styles/custom.scss';

const { store, persistor } = storeContainer;

const CURRENT_APP_VERSION = '1.0.01';

const App = () => {
	useEffect(() => {
		const storedVersion = localStorage.getItem('app_version');
		if (storedVersion !== CURRENT_APP_VERSION) {
			caches.keys().then(function (names) {
				for (let name of names) caches.delete(name);
			});
			localStorage.clear();
			sessionStorage.clear();
			localStorage.setItem('app_version', CURRENT_APP_VERSION);
			window.location.reload();
		} else {
			initiateGA();
			initiateGTM();
		}
	}, []);

	const initiateGA = () => {
		ReactGA.initialize(process.env.GA_ID, { gaOptions: { name: 'pwa' } });
	};

	const initiateGTM = () => {
		TagManager.initialize({ gtmId: process.env.GTM_ID });
	};

	return (
		<Provider store={store}>
			<IntlProvider
				locale={isoLangCodes.fa}
				messages={fa}
			>
				<PersistGate
					loading={null}
					persistor={persistor}
				>
					<Router basename='/pwa'>
						<PageProvider />
					</Router>
				</PersistGate>
			</IntlProvider>
		</Provider>
	);
};
export default App;
